import { initialize } from 'redux-form';

import { loading, success, handleErrorException } from 'State/actions';

import { RECIPE_GROUPS_FORM_NAME } from 'Common/FormEnum';
import { ControlInfoRecipeGroupsFormEnum } from 'Common/FieldEnum';

import * as types from './types';

export const getRecipeGroups = () => async (dispatch, getState, MPWWebApi) => {
  try {
    dispatch(loading(types.GET_RECIPE_GROUPS_LOADING, true));
    const response = await MPWWebApi.getGeneric('Recipe/GetRecipeGroups');

    dispatch(
      initialize(RECIPE_GROUPS_FORM_NAME, {
        [ControlInfoRecipeGroupsFormEnum.RecipeGroups]: response.data.Data,
      })
    );
    dispatch(success(types.GET_RECIPE_GROUPS_SUCCESS, response.data.Data));
  } catch (error) {
    dispatch(
      handleErrorException(error, types.GET_RECIPE_GROUPS_ERROR, {
        Title: 'Error',
        Message: `Could not retrieve recipe groups.`,
      })
    );
  } finally {
    dispatch(loading(types.GET_RECIPE_GROUPS_LOADING, false));
  }
};

export const writeRecipeGroup = data => async (
  dispatch,
  getState,
  MPWWebApi
) => {
  try {
    dispatch(loading(types.WRITE_RECIPE_GROUPS_LOADING, true));

    const response = await MPWWebApi.postGenericInsertUpdate(
      'Recipe/WriteRecipeGroups',
      data
    );

    dispatch(success(types.WRITE_RECIPE_GROUPS_SUCCESS, response.data.Data));

    dispatch(
      initialize(RECIPE_GROUPS_FORM_NAME, {
        [ControlInfoRecipeGroupsFormEnum.RecipeGroups]: response.data.Data,
      })
    );
    return true;
  } catch (error) {
    dispatch(
      handleErrorException(error, types.WRITE_RECIPE_GROUPS_ERROR, {
        Title: 'Error',
        Message: 'Could not save recipe groups.',
      })
    );
    return false;
  } finally {
    dispatch(loading(types.WRITE_RECIPE_GROUPS_LOADING, false));
  }
};

export const deleteRecipeGroups = data => async (
  dispatch,
  getState,
  MPWWebApi
) => {
  try {
    dispatch(loading(types.DELETE_RECIPE_GROUP_LOADING, true));

    const response = await MPWWebApi.postGenericInsertUpdate(
      'Recipe/WriteRecipeGroups',
      data
    );

    dispatch(success(types.DELETE_RECIPE_GROUP_SUCCESS, response.data.Data));

    dispatch(
      initialize(RECIPE_GROUPS_FORM_NAME, {
        [ControlInfoRecipeGroupsFormEnum.RecipeGroups]: response.data.Data,
      })
    );
    return true;
  } catch (error) {
    dispatch(
      handleErrorException(error, types.DELETE_RECIPE_GROUP_ERROR, {
        Title: 'Error',
        Message: 'Could not delete Recipe Group.',
      })
    );
    return false;
  } finally {
    dispatch(loading(types.DELETE_RECIPE_GROUP_LOADING, false));
  }
};

export const clearError = () => ({
  type: types.CLEAR_ERROR,
});



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/recipeGroup/actions.js